import React, { useState } from 'react';
import faq_plus from "../images/faq_plus.svg";

const FaqItem = ({ question, answer }) => {
    const [open, setOpen] = useState(false);

    return (
        <div
            className={`faq_item ${open ? "open" : ""}`}
            onClick={() => setOpen(!open)}
        >
            <div className="faq_question">
                {question}
                <img src={faq_plus} alt="" className={open ? "rotated" : ""}/>
            </div>

            <div className="faq_answer_wrapper">
                <div className="faq_answer">{answer}</div>
            </div>
        </div>
    );
};

export default FaqItem;
